module.exports = __webpack_public_path__ + "static/030.thumb-548af3b4db6c39c9dcf868a2b9717e00.jpg";